import axios from 'axios';

const form = document.getElementById('contactForm');

if (form) {
  form.addEventListener('submit', (e) => {
    e.preventDefault();

    const name = form.querySelector('input[name=name]');
    const company = form.querySelector('input[name=company]');
    const zip = form.querySelector('input[name=zip]');
    const email = form.querySelector('input[name=email]');
    const tel = form.querySelector('input[name=phone]');
    const message = form.querySelector('textarea');
    const apply = form.querySelector('input[name=apply]');

    const data = new FormData();

    data.append('name', name.value);
    data.append('email', email.value);
    data.append('tel', tel.value);

    if (message) {
      data.append('message', message.value);
    } else {
      data.append('company', company.value);
      data.append('zip', zip.value);
      data.append('apply', 1);
    }

    if (apply) {
      data.append('apply', 1);
    }

    axios.post('/wp-admin/admin-ajax.php?action=submit_contact', data)
      .then(() => {
        form.querySelector('#successMessage').style.display = 'block';

        name.value = '';
        email.value = '';
        tel.value = '';

        if (message) {
          message.value = '';
        } else {
          company.value = '';
          zip.value = '';
        }
      })
  });
}



// WEBPACK FOOTER //
// ./scripts/form.js